import styled from 'styled-components';

import { getSpacing } from 'stylesheetB2c';

const REFRESH_ICON_SIZE = getSpacing(7);

export const RefreshIconContainer = styled.div`
  width: ${getSpacing(9)};
  height: ${REFRESH_ICON_SIZE};
  display: flex;
  justify-content: center;
  font-size: ${REFRESH_ICON_SIZE};
`;
